/**
 * What to show a person when something they did failed.
 *
 * Our own writers throw messages written for people ("This trip is no longer
 * available.", "…changed on another device") and those should be shown. The
 * Firebase SDKs throw errors carrying a `code`, whose messages are written for
 * developers — "Missing or insufficient permissions.", "Failed to get document
 * because the client is offline." — and those get the caller's fallback, which
 * says what didn't happen. The exception is a callable's rate limit: our
 * functions word those for people ("Too many reset requests…").
 */
export function userMessage(err: unknown, fallback: string): string {
  if (!(err instanceof Error)) return fallback;
  const code = (err as { code?: unknown }).code;
  if (typeof code !== 'string') return err.message || fallback;
  return code === 'functions/resource-exhausted' ? err.message : fallback;
}
